import { ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { AccessibilityService } from './../../services/accessibility.service';
import { KeyboardService } from './../../services/keyboard.service';

import { AppComponent } from '../../../app.component';

export class BaseComponent {

  /**
   * Holds the currently focussed component
   */
  static activeElement: BaseComponent;
  public static isReviewMode = false;

  /**
   * element is editable or not
   */
  @Input() isEditable = true;

  /**
   * width of element or component
   */
  width: number;

  /**
   * height of element or component
   */
  height: number;

  /**
   * left position of component
   */
  left: number;

  /**
   * top position of component
   */
  top: number;

  /**
   * default value
   */
  defaultVal: string;

  /**
   * text to be set for component
   */
  @Input() text = '';

  /**
   * min value
   */
  @Input() min: number;

  /**
   * max value
   */
  @Input() max: number;

  /**
   * input change event
   */
  @Output() inputChanged = new EventEmitter<string>();

  /**
   * get current active element
   */
  static getActiveElement(): BaseComponent {
    return this.activeElement;
  }

  /**
   * set active element
   * @param  {BaseComponent} element
   */
  static setActiveElement(element: BaseComponent) {
    this.activeElement = element;
  }

  /**
   * constructor
   * @param  {ElementRef} publicele
   */
  constructor(public ele: ElementRef) {

  }

  /**
   * Render the component
   * @override
   */
  render(): void {
  }

  /**
   * Set component Data
   * @override
   */
  setData(object): void { }

  /**
   * Get component Data.
   * @override
   */
  getData(): object {
    return {};
  }

  /**
   * Set component Accessible
   * @override
   */
  setAccessibilityAttribute(array, useCommon?: boolean, commonId?: string): void {
    if (useCommon && commonId) {
      for (let j = 0; j < array.length; j++) {
        const elem = document.getElementById(array[j]);
        if (elem) {
          const properties: Object = AccessibilityService.getAccessibilityData(commonId);

          const propLength = Object.keys(properties).length;
          for (let i = 0; i < propLength; i++) {
            elem.setAttribute(Object.keys(properties)[i], properties[Object.keys(properties)[i]]);
          }
        }
      }


    } else {
      for (let j = 0; j < array.length; j++) {
        const elem = document.getElementById(array[j]);
        if (elem) {
          const properties: Object = AccessibilityService.getAccessibilityData(array[j]);

          const propLength = Object.keys(properties).length;
          for (let i = 0; i < propLength; i++) {
            elem.setAttribute(Object.keys(properties)[i], properties[Object.keys(properties)[i]]);
          }
        }
      }
    }
  }

  /**
   * handle onfocus event
   * @param  {} event
   */
  onFocus(event): void {
    BaseComponent.setActiveElement(event.target);
    KeyboardService.activeElement = event.target;
  }

  /**
   * handle on blur event
   * @param  {} event
   */
  onBlur(event) {
    KeyboardService.activeElement = null;
  }

  /**
   * Trigger on key down
   * @override
   */
  onKeyDown(event): boolean {
    return true;
  }

  /**
   * Trigger on key up
   * @override
   */
  onKeyUp(event): boolean {
    return true;
  }

  /**
   * Trigger on key press
   * @override
   */
  onKeyPress(event): boolean {
    return true;
  }

  /**
   * Change label into input box
   * @override
   */
  setEditable(bool: boolean): void {
    this.isEditable = bool;
  }

  /**
   * set left.
   * @override
   */
  setLeft(value: number, unit: string): void {
    this.left = value;
    this.ele.nativeElement.style.left = value + unit;
  }

  /**
   * set Top.
   * @override
   */
  setTop(value: number, unit: string): void {
    this.top = value;
    this.ele.nativeElement.style.top = value + unit;
  }

  /**
   * set height.
   * @override
   */
  setHeight(value: number, unit: string): void {
    this.height = value;
    this.ele.nativeElement.style.height = value + unit;
  }

  /**
   * set width.
   * @override
   */
  setWidth(value: number, unit: string): void {
    this.width = value;
    this.ele.nativeElement.style.width = value + unit;
  }

  /** sets default value and text without emitting event.
   * @param  {string} value
   */
  setDefaultVal(value: string) {
    this.defaultVal = value;
    this.text = value;
  }

  /**
   * get default value
   */
  getDefaultVal(): string {
    return this.defaultVal;
  }

  /** sets text and emits input changed event.
   * @param  {string} value
   */
  setText(value: string) {
    if (value.toString() !== this.text.toString()) {
      this.text = value;
      this.inputChanged.emit(value);
    }
  }

  /**
   * get text
   */
  getText(): string {
    return this.text;
  }

  /** sets minimum value of the baseComponent, cases - spinner, slider or textbox's number input
   * @param  {number} value
   */
  setMin(value: number) {
    this.min = value;
  }

  /**
   * get min value
   */
  getMin() {
    return this.min;
  }

  /** sets maximum value of the baseComponent, cases - spinner, slider or textbox's number input
   * @param  {number} value
   */
  setMax(value: number) {
    this.max = value;
  }

  /**
   * get max value
   */
  getMax() {
    return this.max;
  }

  /**
   * set dimensions on resize
   */
  onResize() { }

  getScrollBarWidth() {
    const inner = document.createElement('p');
    inner.style.width = '100%';
    inner.style.height = '200px';

    const outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.top = '0px';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '200px';
    outer.style.height = '150px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);
    const w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    let w2 = inner.offsetWidth;
    if (w1 === w2) { w2 = outer.clientWidth; }

    document.body.removeChild(outer);

    return (w1 - w2);
  }

  public get isReviewMode(){
    return BaseComponent.isReviewMode;
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/base/base.component.ts